export const isEmptyObject = (value) => {
    return (value == null ||
        (typeof value === 'object' && Object.keys(value).length === 0));
};
//# sourceMappingURL=isEmptyObject.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
